import classNames from "classnames"
import useAutoId from "web/hooks/behaviour/useAutoId"

export default function Toggle({ checked, label, onClick, id }) {
  const computedId = useAutoId(id)
  const inputClassName = classNames(
    "absolute block w-5 h-5 rounded-full bg-white border-2 appearance-none cursor-pointer focus:outline-none",
    { "right-0 border-blue-500": checked }
  )

  const labelClassName = classNames(
    "block overflow-hidden h-5 rounded-full bg-gray-300 cursor-pointer",
    { "bg-blue-500": checked }
  )

  return (
    <div className="flex">
      <div className="relative inline-block w-8 select-none align-middle transition duration-200 ease-in">
        <input
          checked={checked}
          type="checkbox"
          name={computedId}
          id={computedId}
          className={inputClassName}
          onChange={onClick}
        />
        <label htmlFor={computedId} className={labelClassName}></label>
      </div>
      <label
        htmlFor={computedId}
        className="ml-2 cursor-pointer text-sm text-gray-700"
      >
        {label}
      </label>
    </div>
  )
}
